import type { ReactNode } from 'react';
import { useDocumentContext } from '@/features/printables/contexts/DocumentContext';
import { Grid } from '@/ui';
import type { WeekRowRange } from '../types';

type Props = {
  children: ReactNode;
  weekIndex?: number;
  monthKey?: string;
  weekRowRange?: WeekRowRange;
};

export const WeekRow = ({
  children,
  weekIndex,
  monthKey,
  weekRowRange,
}: Props) => {
  const { isPrintEnv } = useDocumentContext();

  if (weekRowRange && weekIndex != null) {
    if (weekIndex < weekRowRange.start || weekIndex > weekRowRange.end) {
      return null;
    }
  }

  return (
    <Grid
      flex={isPrintEnv ? '1 1 0' : 1}
      gap={isPrintEnv ? '0.3125em' : { base: '0.15em', md: '0.3125em' }}
      minH={0}
      templateColumns="repeat(7, minmax(0, 1fr))"
      data-measure={
        monthKey != null && weekIndex != null
          ? `week-${monthKey}-${weekIndex}`
          : undefined
      }
    >
      {children}
    </Grid>
  );
};
